import Vue from "vue";
import store from "../store";

Vue.filter("country", (value) => {
    let country = store.getters.collections.countries.filter((country) => country.iso_code_2 == value)[0];

    if(country == undefined || !country.name){
        return value;
    }

    return country.name;
});
